import React from 'react';
import styled, { css } from 'styled-components';
import Wrapper from 'gatsby-theme-vehicles/src/components/preview/components/wrapper';
import PreviewImage from 'gatsby-theme-vehicles/src/components/preview/components/image';
import PreviewTitle from 'gatsby-theme-vehicles/src/components/preview/components/title';
import PreviewSubtitle from 'gatsby-theme-vehicles/src/components/preview/components/subtitle';
import PreviewSpecs from 'gatsby-theme-vehicles/src/components/preview/components/specs';
import PreviewExpected from 'gatsby-theme-vehicles/src/components/preview/components/expected';
import PreviewPrice from 'gatsby-theme-vehicles/src/components/preview/components/price';
import PreviewCompany from 'gatsby-theme-vehicles/src/components/preview/components/company';
import { usePreview } from 'gatsby-theme-vehicles/src/components/preview/provider';
import getPricePropsByField from 'gatsby-theme-vehicles/src/helpers/get-price-props-by-field';

const Preview = ({ className }) => {
  const { vdp } = usePreview();
  const isExpected = vdp.vdpType === 'expected';

  return (
    <Wrapper className={className}>
      {isExpected && (
        <ContentWrapper $dark>
          <PreviewExpected />
        </ContentWrapper>
      )}
      <PreviewImage $columnLayout withLink />
      <ContentWrapper>
        <PreviewTitle fields={['make', 'model']} withLink />
        <PreviewSubtitle field="type" withLink />
        <PreviewSpecs $columnLayout iconVariant />
        {vdp.prices.map(({
          field,
          variant,
          ...props
        }, index) => (
          <PreviewPrice
            key={field}
            $variant={variant}
            $first={index === 0}
            withLink
            {...props}
            {...getPricePropsByField(field, variant)}
          />
        ))}
        <PreviewCompany />
      </ContentWrapper>
    </Wrapper>
  );
};

const ContentWrapper = styled.div`
  padding: 1rem;
  ${({ $dark, theme }) => $dark && css`
    background-color: ${theme.gray01};
    font-weight: bold;
  `}
`;

export default styled(Preview)``;
